import { Component, Input, Output, EventEmitter, forwardRef, OnInit } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

@Component({
  selector: 'ckeditor',
  template: `
    <div class="ckeditor-wrapper">
      <textarea
        class="form-control ckeditor-fallback"
        [placeholder]="placeholder"
        [ngModel]="value"
        (ngModelChange)="onModelChange($event)"
        rows="8"
        style="width:100%; font-size:14px; border:1px solid #ccc; border-radius:4px; padding:8px;"
      ></textarea>
    </div>
  `,
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => CKEditorCompatComponent),
    multi: true
  }]
})
export class CKEditorCompatComponent implements OnInit, ControlValueAccessor {
  @Input() config: any = {};
  @Input() placeholder: string = 'Enter description...';
  @Input() name: string = '';
  @Input() readonly: boolean = false;
  @Output() ready = new EventEmitter<any>();
  @Output() change = new EventEmitter<any>();

  value: string = '';

  private controlOnChange: any = () => {};
  private controlOnTouched: any = () => {};

  ngOnInit() {}

  onModelChange(value: string) {
    this.value = value;
    this.controlOnChange(value);
    this.change.emit({ editor: { getData: () => value } });
  }

  writeValue(value: any): void { this.value = value || ''; }
  registerOnChange(fn: any): void { this.controlOnChange = fn; }
  registerOnTouched(fn: any): void { this.controlOnTouched = fn; }
  setDisabledState(isDisabled: boolean): void { this.readonly = isDisabled; }
}
